import { render, staticRenderFns } from "./SelectWidgetType.vue?vue&type=template&id=05a6b8bc&scoped=true&"
import script from "./SelectWidgetType.vue?vue&type=script&lang=js&"
export * from "./SelectWidgetType.vue?vue&type=script&lang=js&"
import style0 from "./SelectWidgetType.vue?vue&type=style&index=0&id=05a6b8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6b8bc",
  null
  
)

export default component.exports